export const toSlug = string =>
  string
    .split(" ")
    .map(word => word.toLowerCase())
    .join("-");